import { useState } from 'react';

function useForm(initValues = {}) {
  const [values, setValues] = useState(initValues);

  const handleChange = (name) => (e) => {
    setValues({ ...values, [name]: e.target.value });
  };
  const handleChangeAutocomplete = (name) => (e, v) => {
    if (v) setValues({ ...values, [name]: v.label });
    else setValues({ ...values, [name]: '' });
  };
  const setFieldValue = (name, val) => setValues({ ...values, [name]: val });
  const setFieldValues = (val) => setValues({ ...values, ...val });
  const handleReset = () => setValues({});

  return {
    values,
    handleChange,
    handleReset,
    setFieldValue,
    setFieldValues,
    handleChangeAutocomplete,
  };
}

export default useForm;
